{
  "title": "DUNE CIRCUIT",
  "illustration": {
    "asset": "d3-cabinet-original",
    "tile": 0
  },
  "rulesheet": [
    "Dune Ramp then Coast Loop within 8 seconds earns a checkpoint.",
    "Three checkpoints light Pit Stop for Race Multiball.",
    "Multiball: Dune Ramp first. Alternate Ridge and Dune for jackpots."
  ],
  "lighting": {
    "version": 1,
    "palette": {
      "idle": "#FFE0AB",
      "active": "#ED9742",
      "hit": "#FFF0D8",
      "award": "#39D6F4"
    },
    "modes": {
      "raceMultiball": "#39D6F4"
    },
    "cues": {
      "multiball": "multiball",
      "jackpot": "jackpot",
      "qualified": "bank",
      "combo": "combo"
    },
    "paths": {
      "duneRamp": "duneRampArrow",
      "duneRampReturn": "duneRampArrow",
      "ridgeRamp": "ridgeRampArrow",
      "ridgeRampReturn": "ridgeRampArrow"
    }
  }
}
